import Http from './http'
import Servers from './servers'
import Server_Group from "./server-group";
import ServerInstances from "./server-instances";
import Servers_Addresses from "./servers-addresses";
import Storage from "./storage"
import Client from './client'
import ClientGroups from './client-groups'
import ClientOrder from './client-order'
import ClientRequest from './client-request'
import ClientRequestSimcard from './client-request-simcard'
import ClientRequestAction from './client-request-action'
import Project from './project'
import BankPayment from './bank-payment'
import ClientInvoice from "./client-invoice";

import Comments from "./comments";
import Simcard from './simcard'
import Dashboard from './dashboard'
import Support from './support'
import Settings from './settings'
import Auth from './auth'
import Users from './users'
import Rbac from './rbac'
import Status from './status'
import Utilities from './utilities'
import Notification from './notification'
import TelegramNotifications from './telegram-notifications'

// Tariffication
import CompanyContracts from "./company-contracts"
import CompanyTariffs from "./company-tariffs"
import Tariffication from "./tariffication"
// Devices list
import Devices from './devices'
// Device
import Device from './device'
import Device_Config from './device-configuration'
import Device_Rpc from './device-rpc'
import Device_Massive_Rpc from "./device-massive-rpc";
import Device_Location from './device-location'
import Device_Group from './device-group'
import Device_Stats from './device-stats'
import Device_Task from './device-task'
import Device_Test from './device-test'
import Device_Configuration from './device-configuration'
import Device_Log from './device-log'
import Device_Traffic_Alerts from "./device-traffic-alerts";
import Custom_Device_List from './custom-device-list'
import Device_Simcard_Group from './device-simcard-group'
import Device_Snapshot from "./device-snapshot"
import Device_Tariffication from "./device-tariffication"
import DeviceContact from './device-user-contacts'
import DeviceSku from './device-sku'
import DeviceNetworkSettings from './device-network-settings'
// Simcard-binding
import Simcard_Binding from './simcard-binding'
// Tariffication blocked simcard
import TarifficationBlockedSimcard from './tariffication-blocked-simcard'

import Attachments from "./attachments";

import Specifications from "./client-order-specs"
import SpecificationItems from "./client-order-spec-items"
import Device_Traffic_Statistic from "./device-traffic-statistic";
import SupportInboxEmails from "./support-inbox-emails"
import DiadocDocument from "./diadoc-document";
import DiadocObjectLinks from "./diadoc-object-links";
import DiadocDocumentParse from "@/API/v1/diadoc-document-parse";
import Rpc from "@/API/v1/rpc";
import Reports from "@/API/v1/reports";

export default {
  ...Http,
  ...Auth,
  ...Device_Location,
  ...Servers,
  ...Servers_Addresses,
  ...ServerInstances,
  ...Server_Group,
  ...Simcard,
  ...Dashboard,
  ...Devices,
  ...Device,
  ...Device_Config,
  ...Device_Rpc,
  ...Device_Massive_Rpc,
  ...Device_Traffic_Statistic,
  ...Device_Stats,
  ...Device_Task,
  ...Device_Configuration,
  ...Device_Test,
  ...Device_Log,
  ...Device_Traffic_Alerts,
  ...Custom_Device_List,
  ...Device_Snapshot,
  ...Device_Simcard_Group,
  ...Device_Tariffication,
  ...DeviceSku,
  ...DeviceNetworkSettings,
  ...Support,
  ...Settings,
  ...Users,
  ...Rbac,
  ...Client,
  ...ClientGroups,
  ...ClientOrder,
  ...Project,
  ...Comments,
  ...Device_Group,
  ...Utilities,
  ...Status,
  ...Notification,
  ...TelegramNotifications,
  ...CompanyTariffs,
  ...Tariffication,
  ...Simcard_Binding,
  ...DeviceContact,
  ...Storage,
  ...ClientRequest,
  ...ClientRequestSimcard,
  ...ClientRequestAction,
  ...BankPayment,
  ...ClientInvoice,
  ...CompanyContracts,
  ...TarifficationBlockedSimcard,
  ...Attachments,
  ...Specifications,
  ...SpecificationItems,
  ...SupportInboxEmails,
  ...DiadocDocument,
  ...DiadocObjectLinks,
  ...DiadocDocumentParse,
  ...Rpc,
  ...Reports
}
